import { defineStore } from "pinia";
import { commClient } from "fw4-library";
import router from "@app/router";
import { i18n } from "@app/i18n";

export interface IKeyValue{
    Key: number | string;
    Value: number | string;
    AdditionalData?: Record<string, any>
}

export interface IUser{
    Username: string;
    FullName: string;
    NeedsToChangePassword: boolean;
}

export enum IPasswordStatus{
    Success = 1,
    Error = 2,
    Undefined = 3
}

export interface IPasswordChange{
    OldPassword: string;
    NewPassword: string;
    RepeatPassword: string;
    Status: IPasswordStatus;
    DescriptionText: string;
}

export interface IAppNavButton {
    title: string;
    routerName?: string;
    runFunction?: (obj?: any) => void;
    class?: string;
    href?: any;
    img?: string;
    completed?: boolean;
}

export interface IProfileData{
    FirstName: string; 
    LastName: string;
    TaxNumber: string;
    BirthDate: Date | null;
    Msisdn: string;
    Email: string;
}

export enum Meseci{
    januar = 0,
    februar = 1,
    marec = 2,
    april = 3,
    maj = 4,
    junij = 5,
    julij = 6,
    avgust = 7,
    september = 8,
    oktober = 9,
    november = 10,
    december = 11,
}

export interface IAppHelpers{
    ShowChangePassword: boolean;
    ShowNavigation: boolean | null;
}

// STATE
export interface IAppState{
    CountryList : IKeyValue[];
    CountryPhoneList: IKeyValue[];
    PostalCodeList: IKeyValue[];        
    User: IUser;    
    PasswordChange: IPasswordChange;
    AppNavButtons: IAppNavButton[];
    ProfileData: IProfileData;
    AppHelpers: IAppHelpers;
    ShowLoaderMain: boolean;
}

export const useAppStore = defineStore('appStore', {
    state: (): IAppState => {
        return {
            CountryList: [],
            CountryPhoneList: [],
            PostalCodeList: [],                     
            User: {
                Username: "",
                FullName: "",
                NeedsToChangePassword: false
            },
            PasswordChange: {
                OldPassword: "",
                NewPassword: "",
                RepeatPassword: "",
                Status: IPasswordStatus.Success,
                DescriptionText: ""
            },
            AppNavButtons: [],
            ProfileData: {
                FirstName: "", 
                LastName: "",
                TaxNumber: "",
                BirthDate: null,
                Msisdn: "",
                Email: ""
            },
            AppHelpers: {
                ShowChangePassword: false,
                ShowNavigation: null
            },
            ShowLoaderMain: false
        }
    },
    actions: {
        BackToDashboard(){
            router.push({ name: "dashboard_dashboard"});  
        },

        async savePassword() {
            // router.push({name: "app_home"});

            const passwordSaved = (Message: any): void => {
                if(Message.Success){
                    this.AppHelpers.ShowChangePassword = false
                    this.PasswordChange.NewPassword = "";
                    this.PasswordChange.RepeatPassword = "";
                    this.PasswordChange.OldPassword = "";
                    this.PasswordChange.DescriptionText = i18n.global.t("password_change.PASS_SUCCESS");
                }
                else if (Message.Error) {
                    this.PasswordChange.DescriptionText = i18n.global.t("password_change." + Message.Error);
                }
            
            };

            commClient.executeMethod("UserPasswordNew", {
                "OldPassword": this.PasswordChange.OldPassword,
                "NewPassword": this.PasswordChange.NewPassword
            }, passwordSaved);
        },
        cancelSavePassword() {
            router.push({ name: "sign_in"});
        },

        async choseCountry() {
            const loadComplete = (Message: any): void => {
                if (Message) {
                    this.CountryList = Message as IKeyValue[]; 
                } else {
                }
            };

            commClient.executeMethod("sf.CountryList", {}, loadComplete);
        },
        async postalCode() {
            const loadCodeComplete = (Message: any): void => {
                if (Message) {  
                    this.PostalCodeList = Message as IKeyValue[];
                } else {
                }
            };

            commClient.executeMethod("sf.PostalCode",{}, loadCodeComplete);
        },

        GoToDashboard(){
            router.push({name: 'dashboard_dashboard'})
        },

        ShowMainLoader(){
            this.ShowLoaderMain = true;
        },
        
        HideMainLoader(){
            this.ShowLoaderMain = false;
        }
    },
    getters: {
        GetCountryCodeSloOnly: (state) => (isSloCitizen: boolean): IKeyValue[] => {
            if (isSloCitizen) {
                return state.CountryList.slice(0, 1);
            } else {
                return state.CountryList.slice(1);
            }
        },

        GetAbbrCapital() : any{
            return this.User.FullName.split(' ').map(x => x[0]).join('');
        },
    }
});